import React, { useContext, useEffect, useRef, useState } from 'react'
import Loader from '../../../Components/Loader/Loader';
import { useParams } from 'react-router-dom';
import { decodeToken } from 'react-jwt';
import { Toast } from 'primereact/toast';
import { getLabel } from '../../../Services/Language/LanguageService';

import { Messages } from 'primereact/messages';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import QRCode from 'qrcode';

import './ProformaInvoiceStyless.scss';
import { Button } from 'primereact/button';
import { toastShow } from '../../../Services/ToastService';
import { FileUpload } from 'primereact/fileupload';
import axios from 'axios'
import { downloadFile } from '../../../Services/ArchivosService';
import { formatNumberDecimal } from '../../../Services/FormatTemplate';
import { descargarArchivoSubido, eliminarArchivoSubido, getCotizacionesPublic, getCotizacionSubida } from '../../../../API/Ventas/Cotizaciones/CotizacionesRequest';
import { ReporteLang } from '../../../../Screen/Ventas/CotizacionesList/ReporteLang';
import { logoPPFBase64 } from '../../../../Screen/RRHH/Evaluacion/Imgs';
import { getDateString } from '../../../Services/Moment/Luxon';
import { PDFDocument } from "pdf-lib";


const ProformaInvoiceScreen = () => {
    const { token } = useParams();
    const toast = useRef(null);
    const fileUpload = useRef(null)

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [IdFacturaProforma, setIdFacturaProforma] = useState(null);
    const [lenguaje, setLenguaje] = useState('es');
    const messages = useRef(null);
    const [enabled, setEnabled] = useState(false);
    const [archivoAgregado, setArchivoAgregado] = useState([]);

    const [pdfUrl, setPdfUrl] = useState([]);
    const [pdfUrl2, setPdfUrl2] = useState([]);
    const [pdfUrlCombinado, setPdfUrlCombinado] = useState(null);

    const getInfo = async () => {
        setLoading(true);
        const decoded = decodeToken(token);
        if (decoded) {
            setIdFacturaProforma(decoded.IdFacturaProforma);
            const t = await getCotizacionesPublic(decoded.IdFacturaProforma, token);
            setLenguaje(decoded.Lang);
            setData(t);
            setEnabled(false)
            if(t){
                const archivoFormato = await getCotizacionSubida(t[0]?.Encabezado?.Quotation, token);
                setArchivoAgregado(archivoFormato);
                GenerarReporte(t, decoded?.Lang)
            }
        }
        setLoading(false);

    }

    const setLabel = (label) => {
        return getLabel(ReporteLang, label, lenguaje);
    }
    

    const obtenerCantidadPaginas = (doc) => {
        return new Promise((resolve, reject) => {
            doc.getBlob(async (blob) => {
            try {
                const arrayBuffer = await blob.arrayBuffer();
                const pdfDoc = await PDFDocument.load(arrayBuffer);
                const totalPaginas = pdfDoc.getPageCount();
                resolve(totalPaginas);
            } catch (error) {
                reject(error);
            }
            })
        })
    };

    const GenerarReporte = async (datos, lenguaje) => {
        let Encabezado = datos[0]?.Encabezado
        let Detalles = datos[0]?.Detalles
    
        let reporte1 = []
        let reporte2 = []
    
        let CodigoQR
        QRCode.toDataURL(`${Encabezado?.Quotation}`, { errorCorrectionLevel: 'Q' }, (err, url) => { CodigoQR = url })

        const docDefinition = {
          pageSize: "LETTER",
          pageOrientation: "landscape",
          pageMargins: [20, 115, 20, 60],

          // HEADER
          header: function (currentPage, pageCount, pageSize) {
            return [
              {
                widths: ["20%", "*", "15%"],
                columns: [
                  [
                    {
                      image: logoPPFBase64?.logo,
                      colSpan: 2,
                      width: 180,
                      margin: [30, 0, 0, 0],
                    },
                    {},
                  ],
                  [
                    {
                      text: "PRIDE PERFORMANCE FABRICS S.A. DE C.V.",
                      style: "titulo2",
                      margin: [-20, 30, 0, 0],
                    },
                    {
                      text: `Zona libre Pride Performance Fabrics, S.A. de CV. Km 19.5 carretera a occidente, la Acequia, Naco, Quimistán, Santa Bárbara, Honduras.`,
                      style: "titulo3",
                      margin: [-20, 5, 0, 0],
                      fillColor: "#FF0000",
                    },
                  ],
                  [
                    {
                      text: `${getLabel(ReporteLang, "cotizacion", lenguaje)}\n ${Encabezado?.Quotation}`,
                      style: "titulo",
                      margin: [85, 20, 0, 0],
                    },
                    {
                      image: CodigoQR,
                      width: 60,
                      margin: [145, -2, 0, 0],
                    },
                  ],
                ],
              },
            ];
          },

          footer: (currentPage, pageCount) => {
            return {
              table: {
                widths: [450],
                body: [
                  [
                    {
                      text: `${getLabel( ReporteLang, "Pagina", lenguaje )} ${currentPage} / ${pageCount + 2}`,
                      margin: [380, 10, -20, 0],
                      fontSize: 7.5,
                    },
                  ],
                  [
                    {
                      text: `${getLabel(ReporteLang, "datePrint", lenguaje)}: ` + getDateString(new Date()),
                      margin: [30, -20, 30, 0],
                      style: 'textBody1'
                    },
                  ],
                ],
              },
              layout: {
                fillColor: function (rowIndex, node, columnIndex) {
                  return rowIndex % 2 === 0 ? "#FFFFFF" : null;
                },
                defaultBorder: false,
              }
            };
          },

          content: [

            //TABLA INICIAL
            {
              table: {
                widths: ["*", "25%"], 
                body: [
                  [
                    {
                      text: `${getLabel(ReporteLang, "fecha", lenguaje)} ${getDateString(new Date(Encabezado.Date || ""))}`,
                      style: "infoGeneral",
                      margin: [10, 0, 0, 0],
                      border: [false, false, false, false]
                    },
                    {
                      text: `${getLabel(ReporteLang, "agente", lenguaje)} ${Encabezado.UserNameAgent || ""}`,
                      style: "infoGeneral",
                      border: [false, false, false, false]
                    },
                  ], 
                  [
                    {
                      text: `${getLabel(ReporteLang, "cliente", lenguaje)} ${Encabezado.CustomerName || ""}`,
                      style: "infoGeneral",
                      margin: [10, 0, 0, 0],

                      border: [false, false, false, false]
                    },
                    {
                      text: `${getLabel(ReporteLang, "terminoC", lenguaje)} ${Encabezado.TermNamePayment || ""}`,
                      style: "infoGeneral",
                      border: [false, false, false, false]
                    },
                  ], 
                  [
                    {
                      text: `${getLabel(ReporteLang, "Buyer", lenguaje)} ${Encabezado.CompanyName || ""}`,
                      style: "infoGeneral",
                      border: [false, false, false, false],
                      margin: [10, 0, 0, 0],
                    },
                    {
                      text: `${getLabel(ReporteLang, "terminoE", lenguaje)} ${Encabezado.TermNameShitment || ""}`,
                      style: "infoGeneral",
                      border: [false, false, false, false],
                    },
                  ], 
                  [
                    {
                      text: `${getLabel(ReporteLang, "Origin", lenguaje)}: ${Encabezado?.Origin || ""}`,
                      style: "infoGeneral",
                      margin: [10, 0, 0, 5],
                      border: [false, false, false, true],
                      colSpan: 2,
                    },{},
                  ], 
                ],
              },
              margin: [0, 0, 0, 0],
            },

        
            {
              columns: [
                {
                  margin: [5, 15, 5, 0],
                  table: {
                    widths: ['8%', '10%', '25%', '10%', '*', '*', '*', '*', '*', '*'],
                    body: [
                      [
                        { text: ``, style: "headerTable", colSpan: 7, border: [false, false, false, false] }, {}, {}, {}, {}, {},{},
                        { text: `${getLabel(ReporteLang, "CIFPRICES", lenguaje)}`, style: "headerTable", colSpan: 3, },{},{},
                      ],
                      [
                        { text: `${getLabel(ReporteLang, "CONTENT", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                        { text: `${getLabel(ReporteLang, "TYPE", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                        { text: `${getLabel(ReporteLang, "YARN", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                        { text: `${getLabel(ReporteLang, "PROCESS", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                        { text: `${getLabel(ReporteLang, "WEIGHT GSM", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                        { text: `${getLabel(ReporteLang, "CUTTABLE GSM", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                        { text: `${getLabel(ReporteLang, "FULL WIDTH", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                        { text: `${getLabel(ReporteLang, "KG", lenguaje)}`, style: "headerTable", border: [true, false, false, true], },
                        { text: `${getLabel(ReporteLang, "LB", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                        { text: `${getLabel(ReporteLang, "YD", lenguaje)}`, style: "headerTable", border: [false, false, true, true], },
                      ],
                      ...Detalles.flatMap(d => [
                        [
                          { text: `${d?.FabricType || ""}`, style: 'textBody', border: [false, false, false, true], },
                          { text: `${d?.FabricContent || ""}`, style: 'textBody',  border: [false, false, false, true], },
                          { text: `${d?.YarnSpec || ""}`, style: 'textBody',  border: [false, false, false, true],},
                          { text: `${d?.Process || ""}`, style: 'textBody',  border: [false, false, false, true],},
                          { text: `${formatNumberDecimal(d.WeightGSM)}`, style: 'textBody',  border: [false, false, false, true], },
                          { text: `${formatNumberDecimal(d.CuttableGSM)}`, style: 'textBody',  border: [false, false, false, true], },
                          { text: `${formatNumberDecimal(d.FullWidth)}`, style: 'textBody',  border: [false, false, false, true], },
                          { text: `$ ${formatNumberDecimal(d.CifPriceKG)}`, style: 'textBody',  border: [true, false, false, true], },
                          { text: `$ ${formatNumberDecimal(d.CifPriceLB)}`, style: 'textBody',  border: [false, false, false, true], },
                          { text: `$ ${formatNumberDecimal(d.CifPriceYD)}`, style: 'textBody',  border: [false, false, true, true], },
                        ],
                      ]),
                    ],
                  },
                  layout: 'lightHorizontalLines'
                },
              ],
            },

            
            //COMENTARIO
            {
              text: [
                {
                  text: `${getLabel(ReporteLang, "comentario", lenguaje)}: `,
                  style: 'titulo2', 
                },
                {
                  text: `${Encabezado?.Comment || ''}`,
                  style: 'general',
                },
              ],
              margin: [20, 30, 10, 0],
            },


            //FIRMA
            {
              columns: [
                {
                  margin: [0, 60, 0, 0],
      
                  table: {
                    widths: [250, '*', 250],
                    body: [
                      [
                        {
                          border: [false, false, false, false],
                          text: '',
                        },
                        {
                          border: [false, false, false, false],
                          text: '',
                          width: 50,
                        },
                        {
                          border: [false, false, false, false],
                          text: '', 
                        },
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: '',
                        },
                        {
                          border: [false, true, false, false],
                          text: `${getLabel(ReporteLang,"firma",lenguaje)}`,
                          style: 'firmas', 

                        },
                        {
                          border: [false, false, false, false],
                          text: '',
                        },
                      ]

                    ]
                  }
                }
              ]
            },

          ],

          // ESTILOS
          styles: {
            titulo: {
              fontSize: 11,
              bold: true,
              alignment: "center",
            },
            titulo2: {
              fontSize: 8.5,
              bold: true,
              alignment: "justify",
            },
            general: {
              fontSize: 8.5,
              alignment: "justify",
            },
            titulo3: {
              fontSize: 8.5,
              semmibold: true,
              alignment: "justify",
            },
            header: {
              fontSize: 9,
              alignment: "justify",
              bold: true,
            },
            infoGeneral: {
              fontSize: 8.5,
              alignment: 'justify'
            },
            headerTable: {
              fontSize: 7.5,
              alignment: "center",
              bold: true,
            },
            headerTable1: {
              fontSize: 8,
              // alignment: "center",
              bold: true,
            },
            textBody: {
              fontSize: 8,
              alignment: "center",
            },  
            textBody1: {
              fontSize: 8,
              alignment: "justify",
            },   
            textBody2: {
              fontSize: 8,
              alignment: "right",
            },            
            textTotales: {
              bold: true,
              fontSize: 10,
              alignment: "right",
            },
            textTotales2: {
              // bold: true,
              fontSize: 10,
              alignment: "right",
            },
            footer: {
              fontSize: 7.5,
              alignment: "left",
              margin: [30, 0, 5, 0],
            },
            firmas: {
              fontSize: 8,
              bold: true,
              alignment: "center",
              lineHeight: 1,
            },
            //CONTENIDO
            title: {
              fontSize: 13,
              bold: true,
              alignment: "center",
            },
            text1: {
              fontSize: 9,
              alignment: "justify",
            },
            text1_1: {
              fontSize: 9,
              alignment: "justify",
              bold: true,
            },
            text2: {
              fontSize: 9,
              bold: true,
              alignment: "justify",
            },
            textBlue: {
              fontSize: 9,
              bold: true,
              alignment: "justify",
              color: "blue",
            },
            textRed: {
              fontSize: 9,
              bold: true,
              alignment: "justify",
              color: "red",
            },
          },
        };
    
        const doc = pdfMake.createPdf(docDefinition);

        await new Promise((resolve) => {
          doc.getDataUrl((url) => {
            reporte1.push(url);
            resolve();
          });
        });
    
        setPdfUrl(reporte1);
    
        let cantPag = await obtenerCantidadPaginas(doc);
    
        const docDefinitionDoc = {
          pageSize: "LETTER",
          pageOrientation: "portrait",
          pageMargins: [40, 115, 40, 60],
    
          // HEADER
          header: function (currentPage, pageCount, pageSize) {
            return [
              {
                widths: ["20%", "*", "15%"],
                columns: [
                  [
                    {
                      image: logoPPFBase64?.logo,
                      width: 180,
                      margin: [20, 10, -10, -10],
                      border: [true, true, true, true],
                    },
                    {},
                  ],
                  [
                    {
                      text: "PRIDE PERFORMANCE FABRICS S.A. DE C.V.",
                      style: "titulo2",
                      margin: [-20, 30, 0, 0],
                    },
                    {
                      text: `Zona libre Pride Performance Fabrics, S.A. de CV. Km 19.5 \ncarretera a occidente, la Acequia, Naco, Quimistán, \nSanta Bárbara, Honduras.`,
                      style: "titulo3",
                      margin: [-20, 5, 0, 0],
                      fillColor: "#FF0000",
                    },
                  ],
                  [
                    {
                      text: `${getLabel(ReporteLang, "cotizacion", lenguaje)}\n ${Encabezado?.Quotation}`,
                      style: "titulo",
                      margin: [0, 20, 0, 0],
                    },
                    {
                      image: CodigoQR,
                      width: 60,
                      margin: [75, -2, 0, 0],
                    },
                  ],
                ],
              },
            ];
          },
    
          footer: (currentPage, pageCount) => {
            return {
              table: {
                widths: [450],
                body: [
                  [
                    {
                      text: `${getLabel( ReporteLang, "Pagina", lenguaje )} ${currentPage + cantPag} / ${pageCount + cantPag}`,
                      margin: [280, 10, -20, 0],
                      fontSize: 7.5,
                    },
                  ],
                  [
                    {
                      text: `${getLabel(ReporteLang, "datePrint", lenguaje)}: ` + getDateString(new Date()),
                      margin: [30, -20, 30, 0],
                      style: 'textBody1'
                    },
                  ],
                ],
              },
              layout: {
                fillColor: function (rowIndex, node, columnIndex) {
                  return rowIndex % 2 === 0 ? "#FFFFFF" : null;
                },
                defaultBorder: false,
              }
            };
          },
    
          content: [
            //CONTENIDO
            {
              text: `${getLabel(ReporteLang,"title",lenguaje)}`,
              style: 'title', 
            },
            {
              text: `${getLabel(ReporteLang,"text1",lenguaje)}`,
              style: 'text1', 
              margin: [15, 15, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text2",lenguaje)}`,
              style: 'text1', 
              margin: [15, 15, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"payment",lenguaje)}`,
              style: 'text2', 
              margin: [15, 15, 15, 0],
            },
            {
              text: [
                {
                  text: `${getLabel(ReporteLang, "text3", lenguaje)}`, 
                  style: 'text1',
                },
                {
                  text: ` ${Encabezado?.TermNamePayment || ''}`,  
                  style: 'textBlue',
                },
                {
                  text: `${getLabel(ReporteLang, "text3_2", lenguaje)}`,  
                  style: 'text1',
                }
              ],
              margin: [35, 5, 15, 0], 
            },
            {
              text: [
                {
                  text: `${getLabel(ReporteLang,"text4",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${Encabezado?.PorcentajePenalizacion || '0'}`,
                  style: 'textRed', 
                },
                {
                  text: `${getLabel(ReporteLang,"text4_1",lenguaje)}`,
                  style: 'textRed', 
                },
                {
                  text: `${getLabel(ReporteLang,"text4_2",lenguaje)}`,
                  style: 'text1', 
                },
              ],
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"bank",lenguaje)}`,
              style: 'text2', 
              margin: [15, 15, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text5",lenguaje)}`,
              style: 'text1', 
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text6",lenguaje)}`,
              style: 'text1', 
              margin: [45, 5, 15, 0],
            },
            {
              text: [
                {
                  text: `${getLabel(ReporteLang,"shipping",lenguaje)}`,
                  style: 'text2', 
                },
                {
                  text: [
                    {
                      text: ` ${Encabezado?.Porcentaje || '0'}`,
                      style: 'text1', 
                    },
                    {
                      text: `${getLabel(ReporteLang,"text7",lenguaje)}`,
                      style: 'text1', 
                    },
                  ]
                }
              ],
              margin: [15, 15, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"yarn",lenguaje)}`,
              style: 'text2', 
              margin: [15, 15, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text8",lenguaje)}`,
              style: 'text1', 
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"Non",lenguaje)}`,
              style: 'text2', 
              margin: [15, 15, 15, 0],
            },
            {
              text: [
                {
                  text: `${getLabel(ReporteLang,"text9",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text9_1",lenguaje)}`,
                  style: 'text1_1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text9_2",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text9_3",lenguaje)}`,
                  style: 'text1_1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text9_4",lenguaje)}`,
                  style: 'text1', 
                },
              ],
              margin: [35, 5, 15, 0],
            },
            {
              text: [
                {
                  text: `${getLabel(ReporteLang,"text10",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text10_1",lenguaje)}`,
                  style: 'text1_1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text10_2",lenguaje)}`,
                  style: 'text1', 
                },
              ],
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"validation",lenguaje)}`,
              style: 'text2', 
              margin: [15, 15, 15, 0],
            },
            {
              text: [
                {
                  text: `${getLabel(ReporteLang,"text11",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text11_1",lenguaje)}`,
                  style: 'text1_1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text11_2",lenguaje)}`,
                  style: 'text1', 
                },
              ],
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text12",lenguaje)}`,
              style: 'text1', 
              margin: [35, 5, 15, 0],
            },
            {
              text: [
                {
                  text: `${getLabel(ReporteLang,"text13",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${Encabezado?.CustomerName || ''}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text13_1",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${Encabezado?.CustomerName || ''}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text13_2",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${Encabezado?.CustomerName || ''}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text13_3",lenguaje)}`,
                  style: 'text1', 
                },
                
              ],
              margin: [35, 5, 15, 0],
            },
            {
              text:[
                {
                  text: `${getLabel(ReporteLang,"text14",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text14_1",lenguaje)}`,
                  style: 'text1_1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text14_2",lenguaje)}`,
                  style: 'text1', 
                },
              ],
              margin: [35, 5, 15, 0],
            },
            {
              text: [
                {
                  text: `${getLabel(ReporteLang,"text15",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text15_1",lenguaje)}`,
                  style: 'text1_1', 
                },
              ],
              margin: [35, 5, 15, 50],
            },
            {
              text: `${getLabel(ReporteLang,"return",lenguaje)}`,
              style: 'text2', 
              margin: [15, 15, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text16",lenguaje)}`,
              style: 'text1', 
              margin: [35, 10, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"types",lenguaje)}`,
              style: 'text2', 
              margin: [15, 15, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text17",lenguaje)}`,
              style: 'text1', 
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"cargos",lenguaje)}`,
              style: 'text2', 
              margin: [15, 15, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text18",lenguaje)}`,
              style: 'text1', 
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text19",lenguaje)}`,
              style: 'text1', 
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text20",lenguaje)}`,
              style: 'text1', 
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text21",lenguaje)}`,
              style: 'text1', 
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"fuerza",lenguaje)}`,
              style: 'text2', 
              margin: [15, 15, 15, 0],
            },
            {
              text: [
                {
                  text: `${getLabel(ReporteLang,"text22",lenguaje)}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text22_1",lenguaje)}`,
                  style: 'text1_1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text22_2",lenguaje)}`,
                  style: 'text1', 
                },
              ], 
              margin: [35, 5, 15, 0],
            },
            {
              text: `${getLabel(ReporteLang,"text23",lenguaje)}`,
              style: 'text1', 
              margin: [15, 25, 15, 0],
            },
    
    
            //FIRMAS
            {
              columns: [
                {
                  margin: [30, 125, 30, 0],
                  table: {
                    widths: ['*', '*', '*'],
                    body: [
                      [
                        {
                          border: [false, true, false, false],
                          text: `${getLabel(ReporteLang,"firmaContenido",lenguaje)}`,
                          style: 'firmas', 
                        },
                        {
                          border: [false, false, false, false],
                          text: '', width: [100]
                        },
                        {
                          border: [false, true, false, false],
                          text: `${getLabel(ReporteLang,"firmaContenido",lenguaje)}`,
                          style: 'firmas', 
                        },
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: `${getLabel(ReporteLang,"firmaContenido1",lenguaje)}`,
                          style: 'firmas', 
                        },
                        {
                          border: [false, false, false, false],
                          text: '', width: [100]
                        },
                        {
                          border: [false, false, false, false],
                          text: `${Encabezado?.CustomerName || ''}`,
                          style: 'firmas', 
                        },
                      ]
                    ]
                  }
                }
              ]
            },
    
          ],
    
          // ESTILOS
          styles: {
            titulo: {
              fontSize: 11,
              bold: true,
              alignment: "center",
            },
            titulo2: {
              fontSize: 8.5,
              bold: true,
              alignment: "justify",
            },
            general: {
              fontSize: 8.5,
              alignment: "justify",
            },
            titulo3: {
              fontSize: 8.5,
              semmibold: true,
              alignment: "justify",
            },
            header: {
              fontSize: 9,
              alignment: "justify",
              bold: true,
            },
            infoGeneral: {
              fontSize: 8.5,
              alignment: 'justify'
            },
            headerTable: {
              fontSize: 7.5,
              alignment: "center",
              bold: true,
            },
            headerTable1: {
              fontSize: 8,
              // alignment: "center",
              bold: true,
            },
            textBody: {
              fontSize: 8,
              alignment: "center",
            },  
            textBody1: {
              fontSize: 8,
              alignment: "justify",
            },   
            textBody2: {
              fontSize: 8,
              alignment: "right",
            },            
            textTotales: {
              bold: true,
              fontSize: 10,
              alignment: "right",
            },
            textTotales2: {
              // bold: true,
              fontSize: 10,
              alignment: "right",
            },
            footer: {
              fontSize: 7.5,
              alignment: "left",
              margin: [30, 0, 5, 0],
            },
            firmas: {
              fontSize: 8,
              bold: true,
              alignment: "center",
              lineHeight: 1,
            },
            //CONTENIDO
            title: {
              fontSize: 13,
              bold: true,
              alignment: "center",
            },
            text1: {
              fontSize: 9,
              alignment: "justify",
            },
            text1_1: {
              fontSize: 9,
              alignment: "justify",
              bold: true,
            },
            text2: {
              fontSize: 9,
              bold: true,
              alignment: "justify",
            },
            textBlue: {
              fontSize: 9,
              bold: true,
              alignment: "justify",
              color: "blue",
            },
            textRed: {
              fontSize: 9,
              bold: true,
              alignment: "justify",
              color: "red",
            },
          },
        };
    
        const doc2 = pdfMake.createPdf(docDefinitionDoc);
    
    
        await new Promise((resolve) => {
          doc2.getDataUrl((url) => {
            reporte2.push(url);
            resolve();
          });
        });
    
        setPdfUrl2(reporte2);
    
    };
    
    const combinarPDFs = async (pdf1, pdf2) => {
        const dataUnida = [...pdf1, ...pdf2];
      
        if (!dataUnida || dataUnida.length === 0) {
          return;
        }
    
        try {
          const pdfDoc = await PDFDocument.create();
    
          for (const pdfBase64 of dataUnida) {
            const pdfBytes = await fetch(pdfBase64).then((res) =>
              res.arrayBuffer()
            );
            const pdfDocTemp = await PDFDocument.load(pdfBytes);
            const pages = await pdfDoc.copyPages(
              pdfDocTemp,
              pdfDocTemp.getPageIndices()
            );
            pages.forEach((page) => pdfDoc.addPage(page));
          }
    
          // console.log(pdfDoc.getPageCount(),'**************');
    
          const mergedPdfBytes = await pdfDoc.save();
    
          // Crear un Blob y una URL temporal
          const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
    
          setPdfUrlCombinado(blobUrl); // Seteamos la URL combinada del PDF
        } catch (error) {
          console.error("Error al combinar los PDFs:", error);
        }
    };

    const uploadFile = async (e) => {
        if(archivoAgregado?.length > 0){
            toastShow(toast, 'warn', 'Advertencia',`Ya existe una cotizacion firmada. Elimine la anterior para agregar una nueva.`);
            fileUpload.current.clear();
        }else{
            setLoading(true);
            let file = e.files[0];
            let Quotation = data[0].Encabezado?.Quotation
    
    
            var formData = new FormData();
            formData.append('file', file);
    
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL}/Ventas/Cotizaciones/UploadFile/${Quotation}?${Date.now()}`, 
                    formData, 
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'x-access-token': token || localStorage.getItem(process.env.REACT_APP_StorageToken),
                        }
                    }
                );
    
        
                // Verifica si el código de estado es exitoso
                if (response.status >= 200 && response.status < 300) {
                    if (toast) {
                        messages.current.show({
                            severity: response.data.data?.severity || 'success',
                            summary: response.data.data?.message || 'Archivo subido correctamente',
                            life: 10000,
                            icon: 'pi pi-check-circle',
                            closable: false,
                        });
                        toastShow(toast, 'success', 'Archivo Agregado');
                        setEnabled(true);
                        setTimeout(() => {
                            obtenerArchivo()
                            setLoading(false);
                        }, 1500);
                    }
                    fileUpload.current.clear();
                } else {
                    console.warn('Código de estado no exitoso:', response.status);
                    if (toast) {
                        toastShow(toast, 'error', `Error al subir archivo: Código ${response.status}`);
                    }
                }
            } catch (error) {
                console.error('Error durante la subida del archivo:', error);

                const statusCode = error.response?.status || 'Sin código';
                const errorMessage = error.response?.data?.message || 'Error desconocido al subir el archivo';
        
                if (toast) {
                    toastShow(toast, 'error', `Error al subir el archivo: ${errorMessage}`, {
                        statusCode,
                        detalles: error.response?.data || error.message,
                    });
                }
            }
            setLoading(false);
        }
    }

    const obtenerArchivo = async () => {
        const archivoFormato = await getCotizacionSubida(data[0]?.Encabezado?.Quotation, token);
        setArchivoAgregado(archivoFormato);
    }

    const descargarArchivo = async (nombre) => {
        const resp = await descargarArchivoSubido(data[0]?.Encabezado?.Quotation, nombre, token)
        if(resp){
            downloadFile(resp, nombre);
        }else{
            toastShow(toast, 'error', 'Error', 'Error al descargar el archivo');
        }
    }

    const eliminarArchivo = async (nombre) => {
        setLoading(true)
        const resp = await eliminarArchivoSubido(data[0]?.Encabezado?.Quotation, nombre, token)
        if(resp === 1){
            toastShow( toast, "success", "Eliminado", "Archivo eliminado correctamente.");
            setArchivoAgregado(archivoAgregado.filter((archivo) => archivo !== nombre));
            setEnabled(false)
        }else{
            toastShow( toast, "error", "Error", "Error al eliminar el archivo.");
        }
        setTimeout(() => {
            setLoading(false)
        }, 700);
    }

    useEffect(() => {
        getInfo();
    }, []);

    
    useEffect(() => {
    if(pdfUrl && pdfUrl2){
        combinarPDFs(pdfUrl, pdfUrl2);
    }
    }, [pdfUrl, pdfUrl2]);


    return (
        <div className='tablePerformaInvoiceContainer' style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <div style={{ textAlign:'center' }}>
                <div>
                    <Loader loading={loading} />
                    <Toast ref={toast} />
                    {
                        IdFacturaProforma && lenguaje ? 
                        <div>
                            {data?.length > 0 ? <div>
                                <div className="col-12">
                                    <h1>{setLabel('Titulo')}</h1>
                                    <h3>{setLabel('cotizacion')}: {data[0].Encabezado?.Quotation}</h3>
                                </div>
                                <iframe
                                    src={pdfUrlCombinado}
                                    style={{ width: "60vw", height: "80vh", border: "1px solid #ccc" }}
                                    id="foo"
                                    title="Reporte QR PDF"
                                />

                                <div style={{ width: '70%', marginLeft: '15%', marginTop: '2%', marginBottom: '3%' }}>
                                    <FileUpload
                                        ref={fileUpload}
                                        name="demo"
                                        url="./upload"
                                        customUpload
                                        uploadHandler={uploadFile}
                                        required
                                        auto
                                        maxFileSize={5242880} 
                                        disabled={enabled}
                                    />

                                    <div className="mt-3">
                                        {archivoAgregado?.map((a, i) => (
                                        <div
                                            className="d-flex gap p-2 border mt-2"
                                            style={{ alignItems: "center" }}
                                            key={i}
                                        >
                                            <div className="col-9">{a}</div>
                                            <Button
                                                icon="pi pi-download"
                                                onClick={() => descargarArchivo(a)}
                                            />
                                            <Button
                                                icon="pi pi-trash"
                                                severity="danger"
                                                onClick={() => eliminarArchivo(a)}
                                            />
                                        </div>
                                        ))}
                                    </div>

                                    <h6 style={{textAlign: 'left', fontSize: 12}} className='mt-2' ><strong>{setLabel('muestras')}</strong> {setLabel('textFinal')}</h6>
                                    <br></br>
                                    <br></br>
                                </div>
                                <Messages ref={messages} />
                            </div>
                                :
                                <div>
                                    <h1>{setLabel('Titulo')}</h1>
                                    <h2>{setLabel('noHayDatos')}</h2>
                                </div>
                            }
                        </div>
                            : <div>
                                <h1>{setLabel('Titulo')}</h1>
                                <h2>{setLabel('tokenNoValido')}</h2>
                            </div>
                    }
                </div>
            </div>
        </div>

    )
}

export default ProformaInvoiceScreen



// import React, { useContext, useEffect, useRef, useState } from 'react'
// import Loader from '../../../Components/Loader/Loader';
// import { useParams } from 'react-router-dom';
// import { decodeToken } from 'react-jwt';
// import { getFacturaProforma, getFacturaProformaFile } from '../../../API/Clientes/PerformaInvoiceRequest';
// import { Toast } from 'primereact/toast';
// import { getLabel } from '../../../Services/Language/LanguageService';
// import { ProformaInvoiceLang } from './ProformaInvoiceLang';
// import { ConfigContext } from '../../../Context/ConfigContext/ConfigContext';

// import { Messages } from 'primereact/messages';
// import { Message } from 'primereact/message';

// import './ProformaInvoiceStyless.scss';
// import { Button } from 'primereact/button';
// import { toastShow } from '../../../Services/ToastService';
// import { FileUpload } from 'primereact/fileupload';
// import axios from 'axios'
// import { downloadFile } from '../../../Services/ArchivosService';
// import { formatNumberDecimal } from '../../../Services/FormatTemplate';
// import Card from '../../../Components/Card/Card';

// const ProformaInvoiceScreen = () => {

//     const { config, changeTheme, changeLanguage } = useContext(ConfigContext);

//     const { token } = useParams();
//     const fileUpload = useRef(null)
//     const toast = useRef(null);
//     const messages = useRef(null);
//     const [enabled, setEnabled] = useState(false);


//     const [loading, setLoading] = useState(false);
//     const [data, setData] = useState([]);
//     const [IdFacturaProforma, setIdFacturaProforma] = useState(null);
//     const [lang, setLang] = useState('es');


//     const getInfo = async () => {
//         setLoading(true);
//         const decoded = decodeToken(token);
//         if (decoded) {
//             setIdFacturaProforma(decoded.IdFacturaProforma);
//             const t = await getFacturaProforma(decoded.IdFacturaProforma, token);
//             setLang(decoded.Lang);
//             setEnabled(true)
//             setData(t);
//         } else {

//         }
//         setLoading(false);
//     }

//     const setLabel = (label) => {
//         return getLabel(ProformaInvoiceLang, label, lang);
//     }

//     const getFile = async () => {
//         // console.log('Descargando archivo');
//         setLoading(true);
//         const file = await getFacturaProformaFile(data[0].NoFactura, token);
//         if (file?.data) {
//             downloadFile(file, data[0].NoFactura + '.pdf');
//         } else {
//             toastShow(toast, 'warn', file?.message);
//         }
//         // console.log(file);
//         setLoading(false);
//     }

//     const uploadFile = async (e) => {
//         setLoading(true);
//         // console.log(e);
//         let file = e.files[0];

//         var formData = new FormData();
//         formData.append('file', file);

//         axios.post(`${process.env.REACT_APP_API_URL}/Clientes/Quote/UploadFile/${data[0].NoFactura}?${Date.now()}`, formData, {
//             headers: {
//                 'Content-Type': 'multipart/form-data',
//                 'x-access-token': token ? token : localStorage.getItem(process.env.REACT_APP_StorageToken),
//             }
//         }).then(res => {
//             console.log(res);
//             if (toast) {
//                 messages.current.show({severity: res.data.data.severity, summary: res.data.data.message, life: 10000, icon: 'pi pi-check-circle', closable: false});
//                 // toastShow(toast, 'success', 'Archivo Agregado')
//                 setEnabled(false);
//             }
//             fileUpload.current.clear();
//             // getArchivos()
//         }).catch(err => {
//             if (toast) {
//                 toastShow(toast, 'error', 'Error al subir el archivo')
//             }
//         })
//         setLoading(false);
//     }

//     useEffect(() => {
//         getInfo();
//     }, []);

//     const ordenVenta = (data) => {
//         const totalQuantity = data.Ordenes.reduce((acc, curr) => acc + curr.GeneralQty, 0);
//         const totalSubtotal = data.Ordenes.reduce((acc, curr) => acc + curr.Subtotal, 0);
//         let unidad = data.Ordenes[0]?.UnitSimbol;
//         unidad = unidad ? unidad.charAt(0).toUpperCase() + unidad.slice(1) : unidad;

//         return (
//             <div className="ordenVenta">
//                 <div style={{ width: '100%' }}>
//                     <div style={{ borderTop: '1px solid #ccc', marginBottom: '10px' }}></div>
//                     <h6 style={{textAlign: 'left'}}><strong>{setLabel('sales')}</strong> {data.SalesOrder}</h6>
//                     <h6 style={{textAlign: 'left'}}><strong>{setLabel('destino')}</strong> {data.Country} - {data.FechaExportacionWeb}</h6>
//                     <table>
//                         <thead style={{ backgroundColor: 'transparent' }}>
//                             <tr>
//                                 <th style={{ fontWeight: 'bold', width: '4%', textAlign: 'center' }}>{setLabel('style')}</th>
//                                 <th style={{ fontWeight: 'bold', width: '12%', textAlign: 'center'}}>{setLabel('comodity')}</th>
//                                 <th style={{ fontWeight: 'bold', width: '3%', textAlign: 'center'}}>{setLabel('wid')}</th>
//                                 <th style={{ fontWeight: 'bold', width: '5%',  textAlign: 'center' }}>COLOR</th>
//                                 <th style={{ fontWeight: 'bold', width: '5%', textAlign: 'right' }}>{setLabel('cant')} ( {unidad} )</th>
//                                 <th style={{ fontWeight: 'bold', width: '2%', textAlign: 'right' }}>{setLabel('precio')}</th>
//                                 <th style={{ fontWeight: 'bold', width: '4%', textAlign: 'center' }}>{setLabel('monto')}</th>
//                             </tr>
//                         </thead>

//                         <tbody>
//                             {data.Ordenes.map((orden, index) => (
//                                 <tr key={index}>
//                                     <td>{orden.CustomerOrder}</td>
//                                     <td>{orden.Yarns}</td>
//                                     <td>{orden.Width}</td>
//                                     <td style={{textAlign: 'left'}}>{orden.ColorName}</td>
//                                     <td style={{ textAlign: 'right', paddingRight: '10px' }}>
//                                         {formatNumberDecimal(orden.GeneralQty)}
//                                     </td>
//                                     <td style={{ textAlign: 'right', paddingRight: '10px' }}>
//                                        $ {formatNumberDecimal(orden.UnitPrice)}
//                                     </td>
//                                     <td style={{ textAlign: 'right', paddingRight: '10px' }}>
//                                         {formatNumberDecimal(orden.Subtotal)}
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>

//                         <tfoot>
//                             <tr>
//                                 <td colSpan="3"></td>
//                                 <td style={{ textAlign: 'right', paddingRight: '10px', fontWeight: 'bold', fontSize:12 }}>TOTAL</td>
//                                 <td style={{ textAlign: 'right', paddingRight: '10px', fontWeight: 'bold', fontSize:12 }}>{formatNumberDecimal(totalQuantity)} {unidad}</td>
//                                 <td style={{ textAlign: 'right', paddingRight: '10px', fontWeight: 'bold', fontSize:12 }}></td>
//                                 <td style={{ textAlign: 'right', paddingRight: '10px', fontWeight: 'bold', fontSize:12 }}>$ {formatNumberDecimal(totalSubtotal)}</td>
//                             </tr>
//                         </tfoot>
//                     </table>
//                 </div>


//             </div>
//         );
//     };

//     const tablePerformaInvoice = () => {
//         const totalQuantityAllOrders = data.reduce((acc, currentOrder) => {
//             const totalQuantity = currentOrder.Ordenes.reduce((acc, orden) => acc + orden.GeneralQty, 0);
//             return acc + totalQuantity;
//         }, 0);

//         const totalAllOrders = data.reduce((acc, currentOrder) => {
//             const totalQuantity = currentOrder.Ordenes.reduce((acc, orden) => acc + orden.Subtotal, 0);
//             return acc + totalQuantity;
//         }, 0);

//         return (
//             <div className="tablePerformaInvoice">
//                 <div className="header">
//                     <div className="col-3">
//                         {config.theme === 'light' ? (
//                             <img src="https://were.ppf.com.hn/assets/Logo_PPF_PrimarioH.png" alt="Imagen" className="logo" />
//                         ) : (
//                             <img src="https://were.ppf.com.hn/assets/Logo_PPF_Primario Negro_H.png" alt="Imagen" className="logo" />
//                         )}
//                     </div>
//                     <div className="col-8">
//                         <h1>{setLabel('Titulo')}</h1>
//                         <h3>{setLabel('Codigo')}: {data[0].NoFactura}</h3>
//                     </div>
//                 </div>
//                 <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
//                     <Button
//                         tooltip={setLabel('descargaTool')}
//                         tooltipOptions={{ position: 'left' }}
//                         label={setLabel('descarga')}
//                         icon="pi pi-download"
//                         onClick={getFile}
//                     />
//                 </div>
//                 <div>
//                     {data.map((e) => ordenVenta(e))}

//                     <table className='mt-4'>

//                         <thead style={{ backgroundColor: 'transparent' }}>
//                             <tr>
//                                 <th style={{ fontWeight: 'bold', width: '4%', textAlign: 'center' }}></th>
//                                 <th style={{ fontWeight: 'bold', width: '12%', textAlign: 'center'}}></th>
//                                 <th style={{ fontWeight: 'bold', width: '3%', textAlign: 'center'}}></th>
//                                 <th style={{ fontWeight: 'bold', width: '5%',  textAlign: 'center' }}></th>
//                                 <th style={{ fontWeight: 'bold', width: '5%', textAlign: 'right' }}> </th>
//                                 <th style={{ fontWeight: 'bold', width: '2%', textAlign: 'right' }}></th>
//                                 <th style={{ fontWeight: 'bold', width: '4%', textAlign: 'center' }}></th>
//                             </tr>
//                         </thead>
                        
//                         <tfoot>
//                             <tr>
//                                 <td colSpan="3"></td>
//                                 <td style={{ textAlign: 'right', paddingRight: '10px', fontWeight: 'bold', fontSize:12 }}>Grand Total </td>
//                                 <td style={{ textAlign: 'right', paddingRight: '10px', fontWeight: 'bold', fontSize:12 }}>{formatNumberDecimal(totalQuantityAllOrders)} {data[0].Ordenes[0]?.UnitSimbol}</td>
//                                 <td style={{ textAlign: 'right', paddingRight: '10px', fontWeight: 'bold', fontSize:12 }}></td>
//                                 <td style={{ textAlign: 'right', paddingRight: '10px', fontWeight: 'bold', fontSize:12 }}>$ {formatNumberDecimal(totalAllOrders)}</td>
//                             </tr>
//                         </tfoot>
//                     </table>
//                 </div>
//                 <div className="file mt-4">
//                     {/* <Button className='mb-2' label="Download" icon="pi pi-download" onClick={getFile} /> */}
//                     <h6 style={{textAlign: 'left', fontWeight: 'bold'}} >{setLabel('labelFirmada')}</h6>
//                     <div style={{ width: '100%' }}>
//                         <FileUpload
//                             ref={fileUpload}
//                             name="demo"
//                             url="./upload"
//                             customUpload
//                             uploadHandler={uploadFile}
//                             required
//                             auto
//                             maxFileSize={5242880} // 5 MB
//                             disabled={!enabled}
//                         />
//                     </div>
                    
//                 </div>
//                 <h6 style={{textAlign: 'left', fontSize: 12}} className='mt-3' ><strong>{setLabel('muestras')}</strong> {setLabel('textFinal')}</h6>
//                 <Messages ref={messages} />
//             </div>
//         );
//     };

//     return (
//         <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
//             <div className='tablePerformaInvoiceContainer' style={{ textAlign:'center' }}>

//                 <Card
//                     contenido={
//                         <div>
//                             <Loader loading={loading} />
//                             <Toast ref={toast} />
//                             {
//                                 IdFacturaProforma ? <div>
//                                     {data?.length > 0 ? <div>
//                                         {tablePerformaInvoice()}
//                                     </div>
//                                         :
//                                         <div>
//                                             <h1>{setLabel('Titulo')}</h1>
//                                             <h2>{setLabel('noHayDatos')}</h2>
//                                         </div>
//                                     }
//                                 </div>
//                                     : <div>
//                                         <h1>{setLabel('Titulo')}</h1>
//                                         <h2>{setLabel('tokenNoValido')}</h2>
//                                     </div>
//                             }
//                         </div>
//                     }>
//                 </Card>

//             </div>
//         </div>

//     )
// }

// export default ProformaInvoiceScreen